import React from "react";
import {
    CCard,
    CCardBody,
    CCardHeader,
    CTable,
    CTableBody,
    CTableHead,
    CTableRow,
    CTableHeaderCell,
    CTableDataCell,
    CInput,
    CButton,
    CContainer,
    CRow,
    CCol,
    CCardTitle,
    CCardText,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import {
    cibAzureArtifacts,
    cibBasecamp,
    cibBoeing,
    cibCoderwall,
    cilBraille,
} from "@coreui/icons";
import Helper from "../application/helper";
import CustomerSearchWidget from "../components/CustomerSearchWidget";
import { useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { Line } from "react-chartjs-2";
import "chart.js/auto";
import { useState } from "react";

// MonthlyTransactionSummaryWidget
const MonthlyTransactionSummaryWidget = ({ summary }) => (
    <CCard>
        <CCardHeader>Monthly Transaction Summary</CCardHeader>
        <CCardBody>
            <CRow>
                <CCol md="3">
                    <CCard className="text-white bg-primary text-center">
                        <CCardBody>
                            <blockquote className="card-bodyquote">
                                <h4>{summary.transaction_count}</h4>
                                <footer>Total Transactions</footer>
                            </blockquote>
                        </CCardBody>
                    </CCard>
                </CCol>
                <CCol md="3">
                    <CCard className="text-white bg-success text-center">
                        <CCardBody>
                            <blockquote className="card-bodyquote">
                                <h4>INR {summary.total_deposit}</h4>
                                <footer>Total Deposits</footer>
                            </blockquote>
                        </CCardBody>
                    </CCard>
                </CCol>
                <CCol md="3">
                    <CCard className="text-white bg-danger text-center">
                        <CCardBody>
                            <blockquote className="card-bodyquote">
                                <h4>INR {summary.total_withdrawal}</h4>
                                <footer>Total Withdrawals</footer>
                            </blockquote>
                        </CCardBody>
                    </CCard>
                </CCol>
            </CRow>
        </CCardBody>
    </CCard>
);

// CustomerAccountSummaryWidget
const CustomerAccountSummaryWidget = ({ summary }) => (
    <CCard>
        <CCardHeader>Customer Account Summary</CCardHeader>
        <CCardBody>
            <CRow>
                <CCol md="6">
                    <CCard className="text-white bg-dark text-center">
                        <CCardBody>
                            <blockquote className="card-bodyquote">
                                <h4>{summary.account_count}</h4>
                                <footer>Total Accounts</footer>
                            </blockquote>
                        </CCardBody>
                    </CCard>
                </CCol>
                <CCol md="6">
                    <CCard className="text-white bg-dark text-center">
                        <CCardBody>
                            <blockquote className="card-bodyquote">
                                <h4>INR {summary.total_balance}</h4>
                                <footer>Total Balance</footer>
                            </blockquote>
                        </CCardBody>
                    </CCard>
                </CCol>
            </CRow>
        </CCardBody>
    </CCard>
);

// MostActiveAccountsWidget
const MostActiveAccountsWidget = ({ accounts }) => {
    console.log({ accounts });
    return (
        <CCard>
            <CCardHeader>Most Active Accounts</CCardHeader>
            <CCardBody>
                <CTable>
                    <CTableHead>
                        <CTableRow>
                            <CTableHeaderCell scope="col">#</CTableHeaderCell>
                            <CTableHeaderCell scope="col">
                                Account ID
                            </CTableHeaderCell>
                            <CTableHeaderCell scope="col">
                                Total Transactions
                            </CTableHeaderCell>
                            <CTableHeaderCell scope="col">
                                Customer Name
                            </CTableHeaderCell>
                            <CTableHeaderCell scope="col">
                                Last Transaction Date
                            </CTableHeaderCell>
                        </CTableRow>
                    </CTableHead>
                    <CTableBody>
                        {accounts.map((account, index) => (
                            <CTableRow key={account.customer_account_id}>
                                <CTableHeaderCell scope="row">
                                    {index + 1}
                                </CTableHeaderCell>
                                <CTableDataCell>
                                    {account.customer_account_number}
                                </CTableDataCell>
                                <CTableDataCell>
                                    {account.transaction_count}
                                </CTableDataCell>
                                <CTableDataCell>
                                    {account.customer_name}
                                </CTableDataCell>
                                <CTableDataCell>
                                    {account.last_transaction_date}
                                </CTableDataCell>
                            </CTableRow>
                        ))}
                    </CTableBody>
                </CTable>
            </CCardBody>
        </CCard>
    );
};

// BalanceExtremesWidget
const BalanceExtremesWidget = ({ extremes }) => (
    <CCard>
        <CCardHeader>Balance Extremes</CCardHeader>
        <CCardBody>
            <CRow>
                <CCol md="6">
                    <CCard className="text-white bg-info text-center">
                        <CCardBody>
                            <blockquote className="card-bodyquote">
                                <h4>INR {extremes.max_balance}</h4>
                                <footer>Maximum Balance</footer>
                            </blockquote>
                        </CCardBody>
                    </CCard>
                </CCol>
                <CCol md="6">
                    <CCard className="text-white bg-warning text-center">
                        <CCardBody>
                            <blockquote className="card-bodyquote">
                                <h4>INR {extremes.min_balance}</h4>
                                <footer>Minimum Balance</footer>
                            </blockquote>
                        </CCardBody>
                    </CCard>
                </CCol>
            </CRow>
        </CCardBody>
    </CCard>
);
const DailyTransactionSummaryWidget = ({ summary }) => (
    <CCard>
        <CCardHeader>Daily Transaction Summary</CCardHeader>
        <CCardBody>
            <CRow>
                <CCol md="4">
                    <CCard className="text-white bg-primary text-center">
                        <CCardBody>
                            <blockquote className="card-bodyquote">
                                <h4>{summary.transaction_count}</h4>
                                <footer>Total Transactions</footer>
                            </blockquote>
                        </CCardBody>
                    </CCard>
                </CCol>
                <CCol md="4">
                    <CCard className="text-white bg-success text-center">
                        <CCardBody>
                            <blockquote className="card-bodyquote">
                                <h4>INR {summary.total_deposit}</h4>
                                <footer>Total Deposits</footer>
                            </blockquote>
                        </CCardBody>
                    </CCard>
                </CCol>
                <CCol md="4">
                    <CCard className="text-white bg-danger text-center">
                        <CCardBody>
                            <blockquote className="card-bodyquote">
                                <h4>INR {summary.total_withdrawal}</h4>
                                <footer>Total Withdrawals</footer>
                            </blockquote>
                        </CCardBody>
                    </CCard>
                </CCol>
            </CRow>
        </CCardBody>
    </CCard>
);

// Simplified ChartComponent Placeholder
const ChartComponent = ({ data }) => {
    const chartData = {
        labels: data.map((item) => item.date),
        datasets: [
            {
                label: "Total Deposit",
                data: data.map((item) => item.total_deposit),
                fill: false,
                backgroundColor: "rgb(255, 99, 132)",
                borderColor: "rgba(255, 99, 132, 0.2)",
            },
            {
                label: "Total Withdrawal",
                data: data.map((item) => item.total_withdrawal),
                fill: false,
                backgroundColor: "rgb(75, 192, 192)",
                borderColor: "rgba(75, 192, 192, 0.2)",
            },
        ],
    };

    const options = {
        scales: {
            y: {
                type: "linear", // this would be unnecessary, but shown for clarity
                beginAtZero: true,
            },
            x: {
                type: "category",
            },
        },
    };

    return <Line data={chartData} options={options} />;
};

// Recent Transactions Widget
// Recent Transactions Widget
const RecentTransactionsWidget = ({ data }) => {
    return (
        <CCard>
            <CCardHeader>Recent Transactions</CCardHeader>
            <CCardBody>
                <CTable>
                    <CTableHead>
                        <CTableRow>
                            <CTableHeaderCell scope="col">#</CTableHeaderCell>
                            <CTableHeaderCell scope="col">
                                Account ID
                            </CTableHeaderCell>
                            <CTableHeaderCell scope="col">
                                Transaction Type
                            </CTableHeaderCell>
                            <CTableHeaderCell scope="col">
                                Amount
                            </CTableHeaderCell>
                            <CTableHeaderCell scope="col">
                                Date
                            </CTableHeaderCell>
                            <CTableHeaderCell scope="col">
                                Customer Name
                            </CTableHeaderCell>
                        </CTableRow>
                    </CTableHead>
                    <CTableBody>
                        {data.map((transaction, index) => (
                            <CTableRow key={transaction.id}>
                                <CTableHeaderCell scope="row">
                                    {index + 1}
                                </CTableHeaderCell>
                                <CTableDataCell>
                                    {
                                        transaction.customer_account
                                            .customer_account_number
                                    }
                                </CTableDataCell>
                                <CTableDataCell>
                                    {transaction.deposit
                                        ? "Deposit"
                                        : "Withdrawal"}
                                </CTableDataCell>
                                <CTableDataCell>
                                    {transaction.deposit ??
                                        transaction.withdrawal}
                                </CTableDataCell>
                                <CTableDataCell>
                                    {transaction.created_at}
                                </CTableDataCell>
                                <CTableDataCell>
                                    {transaction.customer_account
                                        ? transaction.customer_account.name
                                        : "N/A"}
                                </CTableDataCell>
                            </CTableRow>
                        ))}
                    </CTableBody>
                </CTable>
            </CCardBody>
        </CCard>
    );
};

// Transaction Trends Widget
const TransactionTrendsWidget = ({ data }) => {
    return (
        <CCard>
            <CCardHeader>Transaction Trends</CCardHeader>
            <CCardBody>
                <ChartComponent data={data} />
            </CCardBody>
        </CCard>
    );
};

// Total Transactions Widget

const TotalTransactionsWidget = ({ info }) => {
    const netBalance = info.total_deposit - info.total_withdrawal;

    return (
        <CCard>
            <CCardHeader>Total Transactions</CCardHeader>
            <CCardBody>
                <CRow>
                    <CCol md="3">
                        <CCard className="text-white bg-primary text-center">
                            <CCardBody>
                                <blockquote className="card-bodyquote">
                                    <h4>{info.transaction_count}</h4>
                                    <footer>Total Transactions</footer>
                                </blockquote>
                            </CCardBody>
                        </CCard>
                    </CCol>
                    <CCol md="3">
                        <CCard className="text-white bg-success text-center">
                            <CCardBody>
                                <blockquote className="card-bodyquote">
                                    <h4>INR {info.total_deposit}</h4>
                                    <footer>Total Deposits</footer>
                                </blockquote>
                            </CCardBody>
                        </CCard>
                    </CCol>
                    <CCol md="3">
                        <CCard className="text-white bg-danger text-center">
                            <CCardBody>
                                <blockquote className="card-bodyquote">
                                    <h4>INR {info.total_withdrawal}</h4>
                                    <footer>Total Withdrawals</footer>
                                </blockquote>
                            </CCardBody>
                        </CCard>
                    </CCol>
                    <CCol md="3">
                        <CCard
                            className={`text-white text-center ${
                                netBalance >= 0 ? "bg-success" : "bg-warning"
                            }`}
                        >
                            <CCardBody>
                                <blockquote className="card-bodyquote">
                                    <h4>INR {netBalance}</h4>
                                    <footer>Net Balance</footer>
                                </blockquote>
                            </CCardBody>
                        </CCard>
                    </CCol>
                </CRow>
            </CCardBody>
        </CCard>
    );
};

const TopDepositAccountsWidget = ({ accounts }) => {
    return (
        <CCard>
            <CCardHeader>Top Deposit Accounts</CCardHeader>
            <CCardBody>
                <CTable>
                    <CTableHead>
                        <CTableRow>
                            <CTableHeaderCell scope="col">#</CTableHeaderCell>
                            <CTableHeaderCell scope="col">
                                Account ID
                            </CTableHeaderCell>
                            <CTableHeaderCell scope="col">
                                Total Deposit
                            </CTableHeaderCell>
                            <CTableHeaderCell scope="col">
                                Customer Name
                            </CTableHeaderCell>
                            <CTableHeaderCell scope="col">
                                Last Transaction Date
                            </CTableHeaderCell>
                        </CTableRow>
                    </CTableHead>
                    <CTableBody>
                        {accounts.map((account, index) => (
                            <CTableRow key={account.customer_account_id}>
                                <CTableHeaderCell scope="row">
                                    {index + 1}
                                </CTableHeaderCell>
                                <CTableDataCell>
                                    {account.customer_account_number}
                                </CTableDataCell>
                                <CTableDataCell>
                                    {account.total_deposit}
                                </CTableDataCell>
                                <CTableDataCell>
                                    {account.customer_name}
                                </CTableDataCell>
                                <CTableDataCell>
                                    {account.last_transaction_date}
                                </CTableDataCell>
                            </CTableRow>
                        ))}
                    </CTableBody>
                </CTable>
            </CCardBody>
        </CCard>
    );
};

const Welcome = (props) => {
    const {
        recentTransactions,
        transactionTrends,
        totalTransactionsInfo,
        topDepositAccounts,
        monthlyTransactionSummary,
        customerAccountSummary,
        mostActiveAccounts,
        balanceExtremes,
        dailyTransactionSummary,
    } = props;
    const auth = useSelector((state) => state.entities.auth);
    const Desktop = ({ children }) => {
        const isDesktop = useMediaQuery({ minWidth: 992 });
        return isDesktop ? children : null;
    };
    const Mobile = ({ children }) => {
        const isMobile = useMediaQuery({ maxWidth: 992 });
        return isMobile ? children : null;
    };
    return (
        <>
            <CContainer fluid className="p-4">
                <Desktop>
                    <CRow className="d-flex justify-content-around mb-4">
                        {[
                            {
                                color: "light",
                                textColor: "black",
                                href: Helper.route("customer-account.add"),
                                title: "Open New Customer Account",
                                icon: cibCoderwall,
                                only_admin: true,
                            },
                            {
                                color: "warning",
                                textColor: "white",
                                href: Helper.route("customer-account.index"),
                                title: "Search/Edit Customer Account",
                                icon: cibBoeing,
                                only_admin: false,
                            },
                            {
                                color: "secondary",
                                textColor: "black",
                                href: Helper.route("customer-ledger-memo.add"),
                                title: "Create New Transaction Memo",
                                icon: cilBraille,
                                only_admin: false,
                            },
                            {
                                color: "danger",
                                textColor: "white",
                                href: Helper.route(
                                    "customer-ledger-memo.index"
                                ),
                                title: "Approve/Reject Memos",
                                icon: cibBasecamp,
                                only_admin: false,
                            },
                            {
                                color: "primary",
                                textColor: "white",
                                href: Helper.route("customer-ledger.index"),
                                title: "Check Transaction Ledger",
                                icon: cibAzureArtifacts,
                                only_admin: true,
                            },
                        ].map((item, index) => (
                            <React.Fragment key={index}>
                                {(auth.is_admin === item.only_admin ||
                                    auth.is_admin) && (
                                    <CCol
                                        lg={2}
                                        sm={5}
                                        md={3}
                                        className={
                                            "d-flex justify-content-center mb-2"
                                        }
                                    >
                                        <a href={item.href}>
                                            <CCard
                                                color={item.color}
                                                textColor={item.textColor}
                                                className="mb-3"
                                                style={{ maxWidth: "13rem" }}
                                            >
                                                <CCardHeader>
                                                    <h5>{item.title}</h5>
                                                </CCardHeader>
                                                <CCardBody>
                                                    <CCardText>
                                                        <CIcon
                                                            color={
                                                                item.textColor
                                                            }
                                                            icon={item.icon}
                                                        />
                                                    </CCardText>
                                                </CCardBody>
                                            </CCard>
                                        </a>
                                    </CCol>
                                )}
                            </React.Fragment>
                        ))}
                    </CRow>
                    <CRow className="mb-4">
                        <CCol md="12">
                            <CustomerSearchWidget />
                        </CCol>
                    </CRow>
                    <CRow className="mb-4">
                        <CCol md="6">
                            <TransactionTrendsWidget data={transactionTrends} />
                            <MonthlyTransactionSummaryWidget
                                summary={monthlyTransactionSummary}
                            />
                            <DailyTransactionSummaryWidget
                                summary={dailyTransactionSummary}
                            />
                        </CCol>
                        <CCol md="6">
                            <BalanceExtremesWidget extremes={balanceExtremes} />
                            <TotalTransactionsWidget
                                info={totalTransactionsInfo}
                            />
                            <CustomerAccountSummaryWidget
                                summary={customerAccountSummary}
                            />
                        </CCol>
                    </CRow>
                    <CRow className="mb-4">
                        <CCol md="12">
                            <TopDepositAccountsWidget
                                accounts={topDepositAccounts}
                            />
                            <MostActiveAccountsWidget
                                accounts={mostActiveAccounts}
                            />
                            <RecentTransactionsWidget
                                data={recentTransactions}
                            />
                        </CCol>
                    </CRow>
                </Desktop>
                <Mobile>
                    <CCard className={`d-flex justify-content-center`}>
                        <CCardHeader>Disha Trust</CCardHeader>
                        <CCardBody>
                            <CCardTitle>Welcome's You</CCardTitle>
                            <CCardText>
                                Your can now create Memos, Search/List Customer
                                List and many more, So Lets Go.
                            </CCardText>
                        </CCardBody>
                    </CCard>
                </Mobile>
            </CContainer>
        </>
    );
};

export default Welcome;
